var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPnsreser4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 87,
    viewBox: "0 0 123 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1V62.8151C0.5 63.3674 0.947715 63.8151 1.5 63.8151H8.20397C8.75626 63.8151 9.20397 63.3674 9.20397 62.8151V35.6149H44.312V62.8151C44.312 63.3674 44.7597 63.8151 45.312 63.8151H52.0159C52.5682 63.8151 53.0159 63.3674 53.0159 62.8151V8.66625V7.53626H89.7805V11.8694V25.4176H98.5029V4.33312C98.5029 1.94001 96.5197 0 94.0734 0H48.1838H45.312C44.7597 0 44.312 0.447716 44.312 1V28.2002H9.20397V1C9.20397 0.447715 8.75626 0 8.20397 0H1.5C0.947715 0 0.5 0.447717 0.5 1Z",
    fill: "url(#paint0_linear_3625_25953)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7805 59.5487C89.7805 61.905 91.733 63.8151 94.1417 63.8151C96.5503 63.8151 98.5029 61.905 98.5029 59.5487V34.7826L89.7805 35.6149V59.5487Z",
    fill: "url(#paint1_linear_3625_25953)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3618 81.1968L80.3741 81.2033L80.3865 81.2097C85.3325 83.7331 90.889 84.9784 97.0233 84.9784C102.297 84.9784 107.107 84.0256 111.426 82.0907L111.436 82.0863L111.446 82.0818C115.098 80.383 118.123 78.0335 120.493 75.0292C121.793 73.3823 121.202 71.1208 119.585 70.0989L116.828 68.3566C115.256 67.3631 113.299 67.8077 112.171 69.0719C110.487 70.9577 108.506 72.401 106.218 73.4122C103.384 74.6647 100.287 75.2987 96.9093 75.2987C92.8731 75.2987 89.28 74.4632 86.0983 72.821C82.915 71.1076 80.4208 68.75 78.5892 65.7353C76.777 62.7523 75.8442 59.2134 75.8442 55.0632C75.8442 50.9129 76.777 47.374 78.5892 44.3911C80.4198 41.378 82.9105 39.0589 86.0876 37.4168L86.0983 37.4113L86.109 37.4055C89.2892 35.6961 92.8781 34.8276 96.9093 34.8276C100.287 34.8276 103.384 35.4617 106.218 36.7141C108.5 37.7224 110.478 39.1848 112.162 41.1159C113.286 42.4043 115.261 42.8662 116.847 41.8637L119.6 40.1239C121.207 39.1084 121.804 36.8663 120.527 35.2177C118.149 32.1489 115.106 29.7901 111.426 28.1417C107.107 26.2067 102.297 25.2539 97.0233 25.2539C90.889 25.2539 85.3325 26.4993 80.3865 29.0227L80.3864 29.0227L80.3776 29.0272C75.516 31.5482 71.6643 35.0506 68.8566 39.5286C66.0308 44.0354 64.6387 49.2308 64.6387 55.0632C64.6387 60.8292 66.0328 66.0191 68.8507 70.5883L68.8507 70.5883L68.8566 70.5978C71.6618 75.0717 75.5082 78.6059 80.3618 81.1968Z",
    stroke: "url(#paint2_linear_3625_25953)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3625_25953",
    x1: 64.6532,
    y1: -3.98845,
    x2: 98.5253,
    y2: 60.4234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3625_25953",
    x1: 64.6532,
    y1: -3.98845,
    x2: 98.5253,
    y2: 60.4234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3625_25953",
    x1: 101.724,
    y1: 23.2086,
    x2: 137.739,
    y2: 65.9468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnsreser4);
export default __webpack_public_path__ + "static/media/pnsreser4.b50bafdfd15bb8229fe354ae907314cc.svg";
export { ForwardRef as ReactComponent };